export default "__VITE_ASSET__BfZ2hzUu__"